import styles from "../styles/CarePlanPaymentUpdatePage.module.less";

const CarePlanPaymentUpdateSuccessPage = () => {
  // TODO: Add in which care plans are affected
  return (
    <div className={styles.content}>
      <div className={styles.title}>Your payment method is updated</div>
      <div className={styles.body}>
        Your card has been charged automatically for any failed care plan payments.
      </div>
    </div>
  );
};

export default CarePlanPaymentUpdateSuccessPage;
